/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Equipment {
    angular.module("meevo.plugins.equipment", []);
}